// extracted by mini-css-extract-plugin
module.exports = {"svg":"style_svg__3A1gB","valve":"style_valve__1DzzT","animate":"style_animate__1uVEw","valveRotate":"style_valveRotate__2ODP5"};